import { getActiveTreatment } from 'frontend/experiments/helpers';
import { ExperimentLike } from 'frontend/experiments/types';
import { ActiveExperimentGetter } from 'frontend/types';

export interface TrialPaywallHeaderCopy {
  heading: string;
  subheading?: string;
}

// Professional trial paywall header experiment
export type TrialPaywallHeaderExperimentTreatment =
  | 'control'
  | 'experiment_1'
  | 'experiment_2'
  | 'experiment_3';

export const trialPaywallHeaderExperiment: ExperimentLike<TrialPaywallHeaderExperimentTreatment> = {
  treatments: ['control', 'experiment_1', 'experiment_2', 'experiment_3'],
  name: 'professional_paywall_header_03_23',
  control: 'control',
};

export function getTrialPaywallHeaderExperimentActiveTreatment(
  activeExperimentGetter: ActiveExperimentGetter,
): TrialPaywallHeaderExperimentTreatment {
  return getActiveTreatment(activeExperimentGetter, trialPaywallHeaderExperiment);
}

export const HEADER_COPY: {
  [key in TrialPaywallHeaderExperimentTreatment]: TrialPaywallHeaderCopy;
} = {
  control: {
    heading: 'How your Premium free trial works',
    subheading: undefined,
  },
  experiment_1: {
    heading: 'How your Premium free trial works',
    subheading: 'Expand your expertise in minutes a day. Cancel anytime.',
  },
  experiment_2: {
    heading: 'How your Premium {TRIAL_LENGTH}-day free trial works',
    subheading: 'Expand your expertise in minutes a day. Cancel anytime.',
  },
  experiment_3: {
    heading: 'How your {TRIAL_LENGTH}-day free trial works',
    subheading: 'Expand your expertise in minutes a day. Cancel anytime.',
  },
};
